"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconCards = function IconCards(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    className: (0, _classnames.default)('Icon', 'IconCards', className),
    style: style
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.36363636,6.72727273 C7.01218243,6.72727273 6.72727273,7.01218243 6.72727273,7.36363636 L6.72727273,13.0909091 C6.72727273,13.442363 7.01218243,13.7272727 7.36363636,13.7272727 L13.0909091,13.7272727 C13.442363,13.7272727 13.7272727,13.442363 13.7272727,13.0909091 L13.7272727,7.36363636 C13.7272727,7.01218243 13.442363,6.72727273 13.0909091,6.72727273 L7.36363636,6.72727273 Z M13.0909091,5.45454545 C14.1452709,5.45454545 15,6.30927457 15,7.36363636 L15,13.0909091 C15,14.1452709 14.1452709,15 13.0909091,15 L7.36363636,15 C6.30927457,15 5.45454545,14.1452709 5.45454545,13.0909091 L5.45454545,7.36363636 C5.45454545,6.30927457 6.30927457,5.45454545 7.36363636,5.45454545 L13.0909091,5.45454545 Z M8.63636364,1 C9.69072543,1 10.5454545,1.85472911 10.5454545,2.90909091 L10.5454545,2.90909091 L10.5454545,3.54545455 C10.5454545,3.89690848 10.2605448,4.18181818 9.90909091,4.18181818 C9.55763698,4.18181818 9.27272727,3.89690848 9.27272727,3.54545455 L9.27272727,3.54545455 L9.27272727,2.90909091 C9.27272727,2.55763698 8.98781757,2.27272727 8.63636364,2.27272727 L8.63636364,2.27272727 L2.90909091,2.27272727 C2.55763698,2.27272727 2.27272727,2.55763698 2.27272727,2.90909091 L2.27272727,2.90909091 L2.27272727,8.63636364 C2.27272727,8.98781757 2.55763698,9.27272727 2.90909091,9.27272727 L2.90909091,9.27272727 L3.54545455,9.27272727 C3.89690848,9.27272727 4.18181818,9.55763698 4.18181818,9.90909091 C4.18181818,10.2605448 3.89690848,10.5454545 3.54545455,10.5454545 L3.54545455,10.5454545 L2.90909091,10.5454545 C1.85472911,10.5454545 1,9.69072543 1,8.63636364 L1,8.63636364 L1,2.90909091 C1,1.85472911 1.85472911,1 2.90909091,1 L2.90909091,1 Z"
  }));
};

var _default = IconCards;
exports.default = _default;